const fallbackCopyTextToClipboard = (text) => {
  const textArea = document.createElement('textarea');
  textArea.value = text;

  // Avoid scrolling to bottom
  textArea.style.top = '0';
  textArea.style.left = '0';
  textArea.style.position = 'fixed';

  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    document.execCommand('copy');
  } catch (err) {
    console.error('Fallback: Could not copy text:', err);
  }

  document.body.removeChild(textArea);
};

export const copyTextToClipboard = async (text) => {
  const copiedResult = await navigator.clipboard?.writeText(text).then(
    () => true,
    (err) => {
      console.error('Async: Could not copy text: ', err);
      return false;
    },
  );

  if (!copiedResult) {
    fallbackCopyTextToClipboard(text);
  }
};

export const debounce = (callback, timeout) => {
  let timer;

  return (...args) => {
    clearTimeout(timer);

    timer = setTimeout(() => {
      callback(...args);
    }, timeout);
  };
};
